import {small, medium, xlarge} from '../../settings/Responsive';
import { ON_CART_FINISHED } from '@process-creative/slate-theme-tools';

const SLIDE_SELECTOR = '[data-slide-selector]';
const SLIDES_CONTAINER_SELECTOR = '[data-slides-container-selector]';
const SLIDER_ARROWS_SELECTOR = '[data-slider-arrows-selector]';
const PREVIOUS_SELECTOR = '[data-previous-selector]';
const NEXT_SELECTOR = '[data-next-selector]';

// classes
const IS_HIDDEN = 'is-hidden';
const HAS_SCROLL_SNAP = 'has-scroll-snap';
const CLASS_IS_DISABLED = 'is-disabled';

const LAYOUTS = {
  xlarge: {
    name: 'xlarge',
    slides: 4,
    width: xlarge,
    class: 'is-4-col'
  },
  medium: {
    name: 'medium',
    slides: 3,
    width: medium,
    class: 'is-3-col'
  },
  small: {
    name: 'small',
    slides: 2,
    width: small,
    class: 'is-2-col'
  },
  mobile: {
    name: 'mobile',
    slides: 1,
    width: 0,
    class: 'is-1-col'
  }
}


export class Slider {

  constructor(container){
    this.container = container
    $(window).on('resize', this.determineLayout.bind(this))
    this.slidesContainer = this.container.find(SLIDES_CONTAINER_SELECTOR)

    this.arrows = this.container.find(SLIDER_ARROWS_SELECTOR)
    this.previous = this.container.find(PREVIOUS_SELECTOR)
    this.next = this.container.find(NEXT_SELECTOR)

    this.previous.on('click touch', this.previousClicked.bind(this))
    this.next.on('click touch', this.nextClicked.bind(this))

    this.onSlidesUpdated();
  }

  onSlidesUpdated(){
    this.slides = this.container.find(SLIDE_SELECTOR);
    this.hasSlides = this.slides.length > 0;
    if(this.hasSlides){
      this.determineLayout();
      this.slidesContainer = this.container.find(SLIDES_CONTAINER_SELECTOR);
      this.container.removeClass(IS_HIDDEN)
      this.checkHideShowArrows();
    }
    else{
      this.container.addClass(IS_HIDDEN)
    }
  }

  checkHideShowArrows(){
    const slideCount = this.slides.length;
    
    if(!slideCount || !this.currentLayout) return

    if(slideCount <= this.currentLayout.slides){
      this.arrows.addClass(IS_HIDDEN);
    }
    else{
      this.arrows.removeClass(IS_HIDDEN);
    }
  }


  previousClicked(){
    this.scrollSlideContainer('left');
  }
  nextClicked(){
    this.scrollSlideContainer('right');
  }

  scrollSlideContainer(direction){
    const slideWidth = this.slides[0].clientWidth;
    const currentScrollVal = this.slidesContainer.scrollLeft();

    this.slidesContainer.removeClass(HAS_SCROLL_SNAP);

    this.slidesContainer.animate(
      {
        scrollLeft: currentScrollVal + (
          direction == 'left' ? slideWidth * -1 : 
          direction == 'right' ? slideWidth : ''
        )
      },
      {
        complete: () => {
          // Removed due to bug with iOS 
          // setTimeout(() => this.slidesContainer.addClass(HAS_SCROLL_SNAP), 5000);
          const currentScrollVal = this.slidesContainer.scrollLeft()

          if(currentScrollVal == 0){
            this.previous.addClass(CLASS_IS_DISABLED)
          }
          else {
            this.previous.removeClass(CLASS_IS_DISABLED)
          }
          
          const approxEndOfSlide = (this.slides.length - this.currentLayout.slides) * slideWidth

          if(approxEndOfSlide > currentScrollVal - 10 && approxEndOfSlide < currentScrollVal + 10){
            this.next.addClass(CLASS_IS_DISABLED)
          }
          else {
            this.next.removeClass(CLASS_IS_DISABLED)
          }
        }
      })
  }



  determineLayout(){
    for(let key in LAYOUTS){
      if(this.slidesContainer.innerWidth() >= LAYOUTS[key].width){
        if(!this.currentLayout || this.currentLayout.name != LAYOUTS[key].name){
          this.updateLayout(LAYOUTS[key])
        }
        break
      }
    }
    
  }


  updateLayout(layout){
    this.currentLayout = layout

    Object.values(LAYOUTS)
    .forEach(l => {
      if(l.name != layout.name){
        this.container.removeClass(l.class)
      }
    })

    this.container.addClass(layout.class)
    this.checkHideShowArrows()

  }



}
